import { useRef, useState, useEffect, useCallback } from "react";

export function useTabIndicator(initialIndex = 0) {
  const containerRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(initialIndex);
  const [indicatorStyle, setIndicatorStyle] = useState({ x: 0, width: 0 });

  const updateIndicator = useCallback(
    (index = activeIndex) => {
      if (!containerRef.current) return;

      const tab = containerRef.current.children[index];
      if (tab) {
        const rect = tab.getBoundingClientRect();
        const containerRect = containerRef.current.getBoundingClientRect();

        setIndicatorStyle({
          x: rect.left - containerRect.left,
          width: rect.width,
        });
      }
    },
    [activeIndex]
  );

  useEffect(() => {
    updateIndicator(activeIndex);

    const handleResize = () => updateIndicator(activeIndex);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [activeIndex, updateIndicator]);

  return {
    containerRef,
    activeIndex,
    setActiveIndex,
    indicatorStyle,
    updateIndicator,
  };
}
